/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseCouncilAdminInvitationDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseInvitationStatisticsDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponsePageCouncilAdminInvitationDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponsePendingInvitationCheckDTO } from '../backend/model';
// @ts-ignore
import type { CreateCouncilAdminInvitationRequest } from '../backend/model';
// @ts-ignore
import type { RespondCouncilAdminInvitationRequest } from '../backend/model';
/**
 * CouncilAdminInvitationsApi - axios parameter creator
 * @export
 */
export const CouncilAdminInvitationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel a pending council admin invitation
         * @summary Cancel invitation
         * @param {number} invitationId Invitation ID
         * @param {string} [reason] Reason for cancellation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelInvitation: async (invitationId: number, reason?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('cancelInvitation', 'invitationId', invitationId)
            const localVarPath = `/api/admin/council-invitations/{invitationId}`
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if there\'s a pending invitation for the email in the council
         * @summary Check pending invitation
         * @param {string} email Email address
         * @param {number} councilId Council ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPendingInvitation: async (email: string, councilId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('checkPendingInvitation', 'email', email)
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('checkPendingInvitation', 'councilId', councilId)
            const localVarPath = `/api/admin/council-invitations/check-pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (councilId !== undefined) {
                localVarQueryParameter['councilId'] = councilId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new council admin invitation for specified email and council
         * @summary Create council admin invitation
         * @param {CreateCouncilAdminInvitationRequest} createCouncilAdminInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation: async (createCouncilAdminInvitationRequest: CreateCouncilAdminInvitationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCouncilAdminInvitationRequest' is not null or undefined
            assertParamExists('createInvitation', 'createCouncilAdminInvitationRequest', createCouncilAdminInvitationRequest)
            const localVarPath = `/api/admin/council-invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCouncilAdminInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated list of all invitations with optional filters
         * @summary Get all invitations
         * @param {number} [councilId] Council ID filter
         * @param {string} [status] Status filter
         * @param {string} [email] Email filter
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sort] Sort field
         * @param {string} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInvitations: async (councilId?: number, status?: string, email?: string, page?: number, size?: number, sort?: string, direction?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/council-invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (councilId !== undefined) {
                localVarQueryParameter['councilId'] = councilId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve invitation details using the invitation token
         * @summary Get invitation by token
         * @param {string} token Invitation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationByToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getInvitationByToken', 'token', token)
            const localVarPath = `/api/admin/council-invitations/token/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics for invitations in a council
         * @summary Get invitation statistics
         * @param {number} councilId Council ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationStatistics: async (councilId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getInvitationStatistics', 'councilId', councilId)
            const localVarPath = `/api/admin/council-invitations/council/{councilId}/statistics`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated list of invitations for a specific council
         * @summary Get invitations for council
         * @param {number} councilId Council ID
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sort] Sort field
         * @param {string} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationsForCouncil: async (councilId: number, page?: number, size?: number, sort?: string, direction?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getInvitationsForCouncil', 'councilId', councilId)
            const localVarPath = `/api/admin/council-invitations/council/{councilId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated list of invitations sent to a specific email
         * @summary Get invitations for email
         * @param {string} email Email address
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sort] Sort field
         * @param {string} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationsForEmail: async (email: string, page?: number, size?: number, sort?: string, direction?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getInvitationsForEmail', 'email', email)
            const localVarPath = `/api/admin/council-invitations/email/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated list of invitations sent by a specific user
         * @summary Get invitations sent by user
         * @param {number} userId User ID
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sort] Sort field
         * @param {string} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationsSentByUser: async (userId: number, page?: number, size?: number, sort?: string, direction?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getInvitationsSentByUser', 'userId', userId)
            const localVarPath = `/api/admin/council-invitations/sent-by/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend an invitation email
         * @summary Resend invitation
         * @param {number} invitationId Invitation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitation: async (invitationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('resendInvitation', 'invitationId', invitationId)
            const localVarPath = `/api/admin/council-invitations/{invitationId}/resend`
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accept or reject a council admin invitation
         * @summary Respond to invitation
         * @param {string} token Invitation token
         * @param {RespondCouncilAdminInvitationRequest} respondCouncilAdminInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToInvitation: async (token: string, respondCouncilAdminInvitationRequest: RespondCouncilAdminInvitationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('respondToInvitation', 'token', token)
            // verify required parameter 'respondCouncilAdminInvitationRequest' is not null or undefined
            assertParamExists('respondToInvitation', 'respondCouncilAdminInvitationRequest', respondCouncilAdminInvitationRequest)
            const localVarPath = `/api/admin/council-invitations/respond/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(respondCouncilAdminInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouncilAdminInvitationsApi - functional programming interface
 * @export
 */
export const CouncilAdminInvitationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouncilAdminInvitationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel a pending council admin invitation
         * @summary Cancel invitation
         * @param {number} invitationId Invitation ID
         * @param {string} [reason] Reason for cancellation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelInvitation(invitationId: number, reason?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCouncilAdminInvitationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelInvitation(invitationId, reason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminInvitationsApi.cancelInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if there\'s a pending invitation for the email in the council
         * @summary Check pending invitation
         * @param {string} email Email address
         * @param {number} councilId Council ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkPendingInvitation(email: string, councilId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePendingInvitationCheckDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkPendingInvitation(email, councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminInvitationsApi.checkPendingInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new council admin invitation for specified email and council
         * @summary Create council admin invitation
         * @param {CreateCouncilAdminInvitationRequest} createCouncilAdminInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvitation(createCouncilAdminInvitationRequest: CreateCouncilAdminInvitationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCouncilAdminInvitationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvitation(createCouncilAdminInvitationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminInvitationsApi.createInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated list of all invitations with optional filters
         * @summary Get all invitations
         * @param {number} [councilId] Council ID filter
         * @param {string} [status] Status filter
         * @param {string} [email] Email filter
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sort] Sort field
         * @param {string} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllInvitations(councilId?: number, status?: string, email?: string, page?: number, size?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePageCouncilAdminInvitationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllInvitations(councilId, status, email, page, size, sort, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminInvitationsApi.getAllInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve invitation details using the invitation token
         * @summary Get invitation by token
         * @param {string} token Invitation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvitationByToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCouncilAdminInvitationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvitationByToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminInvitationsApi.getInvitationByToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get statistics for invitations in a council
         * @summary Get invitation statistics
         * @param {number} councilId Council ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvitationStatistics(councilId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseInvitationStatisticsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvitationStatistics(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminInvitationsApi.getInvitationStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated list of invitations for a specific council
         * @summary Get invitations for council
         * @param {number} councilId Council ID
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sort] Sort field
         * @param {string} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvitationsForCouncil(councilId: number, page?: number, size?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePageCouncilAdminInvitationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvitationsForCouncil(councilId, page, size, sort, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminInvitationsApi.getInvitationsForCouncil']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated list of invitations sent to a specific email
         * @summary Get invitations for email
         * @param {string} email Email address
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sort] Sort field
         * @param {string} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvitationsForEmail(email: string, page?: number, size?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePageCouncilAdminInvitationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvitationsForEmail(email, page, size, sort, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminInvitationsApi.getInvitationsForEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated list of invitations sent by a specific user
         * @summary Get invitations sent by user
         * @param {number} userId User ID
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sort] Sort field
         * @param {string} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvitationsSentByUser(userId: number, page?: number, size?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePageCouncilAdminInvitationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvitationsSentByUser(userId, page, size, sort, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminInvitationsApi.getInvitationsSentByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend an invitation email
         * @summary Resend invitation
         * @param {number} invitationId Invitation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendInvitation(invitationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCouncilAdminInvitationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendInvitation(invitationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminInvitationsApi.resendInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accept or reject a council admin invitation
         * @summary Respond to invitation
         * @param {string} token Invitation token
         * @param {RespondCouncilAdminInvitationRequest} respondCouncilAdminInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondToInvitation(token: string, respondCouncilAdminInvitationRequest: RespondCouncilAdminInvitationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCouncilAdminInvitationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondToInvitation(token, respondCouncilAdminInvitationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminInvitationsApi.respondToInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouncilAdminInvitationsApi - factory interface
 * @export
 */
export const CouncilAdminInvitationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouncilAdminInvitationsApiFp(configuration)
    return {
        /**
         * Cancel a pending council admin invitation
         * @summary Cancel invitation
         * @param {number} invitationId Invitation ID
         * @param {string} [reason] Reason for cancellation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelInvitation(invitationId: number, reason?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCouncilAdminInvitationDTO> {
            return localVarFp.cancelInvitation(invitationId, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if there\'s a pending invitation for the email in the council
         * @summary Check pending invitation
         * @param {string} email Email address
         * @param {number} councilId Council ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPendingInvitation(email: string, councilId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePendingInvitationCheckDTO> {
            return localVarFp.checkPendingInvitation(email, councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new council admin invitation for specified email and council
         * @summary Create council admin invitation
         * @param {CreateCouncilAdminInvitationRequest} createCouncilAdminInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation(createCouncilAdminInvitationRequest: CreateCouncilAdminInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCouncilAdminInvitationDTO> {
            return localVarFp.createInvitation(createCouncilAdminInvitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated list of all invitations with optional filters
         * @summary Get all invitations
         * @param {number} [councilId] Council ID filter
         * @param {string} [status] Status filter
         * @param {string} [email] Email filter
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sort] Sort field
         * @param {string} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInvitations(councilId?: number, status?: string, email?: string, page?: number, size?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePageCouncilAdminInvitationDTO> {
            return localVarFp.getAllInvitations(councilId, status, email, page, size, sort, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve invitation details using the invitation token
         * @summary Get invitation by token
         * @param {string} token Invitation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationByToken(token: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCouncilAdminInvitationDTO> {
            return localVarFp.getInvitationByToken(token, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics for invitations in a council
         * @summary Get invitation statistics
         * @param {number} councilId Council ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationStatistics(councilId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseInvitationStatisticsDTO> {
            return localVarFp.getInvitationStatistics(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated list of invitations for a specific council
         * @summary Get invitations for council
         * @param {number} councilId Council ID
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sort] Sort field
         * @param {string} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationsForCouncil(councilId: number, page?: number, size?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePageCouncilAdminInvitationDTO> {
            return localVarFp.getInvitationsForCouncil(councilId, page, size, sort, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated list of invitations sent to a specific email
         * @summary Get invitations for email
         * @param {string} email Email address
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sort] Sort field
         * @param {string} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationsForEmail(email: string, page?: number, size?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePageCouncilAdminInvitationDTO> {
            return localVarFp.getInvitationsForEmail(email, page, size, sort, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated list of invitations sent by a specific user
         * @summary Get invitations sent by user
         * @param {number} userId User ID
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sort] Sort field
         * @param {string} [direction] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationsSentByUser(userId: number, page?: number, size?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePageCouncilAdminInvitationDTO> {
            return localVarFp.getInvitationsSentByUser(userId, page, size, sort, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend an invitation email
         * @summary Resend invitation
         * @param {number} invitationId Invitation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitation(invitationId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCouncilAdminInvitationDTO> {
            return localVarFp.resendInvitation(invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Accept or reject a council admin invitation
         * @summary Respond to invitation
         * @param {string} token Invitation token
         * @param {RespondCouncilAdminInvitationRequest} respondCouncilAdminInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToInvitation(token: string, respondCouncilAdminInvitationRequest: RespondCouncilAdminInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCouncilAdminInvitationDTO> {
            return localVarFp.respondToInvitation(token, respondCouncilAdminInvitationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouncilAdminInvitationsApi - object-oriented interface
 * @export
 * @class CouncilAdminInvitationsApi
 * @extends {BaseAPI}
 */
export class CouncilAdminInvitationsApi extends BaseAPI {
    /**
     * Cancel a pending council admin invitation
     * @summary Cancel invitation
     * @param {number} invitationId Invitation ID
     * @param {string} [reason] Reason for cancellation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminInvitationsApi
     */
    public cancelInvitation(invitationId: number, reason?: string, options?: RawAxiosRequestConfig) {
        return CouncilAdminInvitationsApiFp(this.configuration).cancelInvitation(invitationId, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if there\'s a pending invitation for the email in the council
     * @summary Check pending invitation
     * @param {string} email Email address
     * @param {number} councilId Council ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminInvitationsApi
     */
    public checkPendingInvitation(email: string, councilId: number, options?: RawAxiosRequestConfig) {
        return CouncilAdminInvitationsApiFp(this.configuration).checkPendingInvitation(email, councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new council admin invitation for specified email and council
     * @summary Create council admin invitation
     * @param {CreateCouncilAdminInvitationRequest} createCouncilAdminInvitationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminInvitationsApi
     */
    public createInvitation(createCouncilAdminInvitationRequest: CreateCouncilAdminInvitationRequest, options?: RawAxiosRequestConfig) {
        return CouncilAdminInvitationsApiFp(this.configuration).createInvitation(createCouncilAdminInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated list of all invitations with optional filters
     * @summary Get all invitations
     * @param {number} [councilId] Council ID filter
     * @param {string} [status] Status filter
     * @param {string} [email] Email filter
     * @param {number} [page] Page number (0-based)
     * @param {number} [size] Page size
     * @param {string} [sort] Sort field
     * @param {string} [direction] Sort direction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminInvitationsApi
     */
    public getAllInvitations(councilId?: number, status?: string, email?: string, page?: number, size?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig) {
        return CouncilAdminInvitationsApiFp(this.configuration).getAllInvitations(councilId, status, email, page, size, sort, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve invitation details using the invitation token
     * @summary Get invitation by token
     * @param {string} token Invitation token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminInvitationsApi
     */
    public getInvitationByToken(token: string, options?: RawAxiosRequestConfig) {
        return CouncilAdminInvitationsApiFp(this.configuration).getInvitationByToken(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics for invitations in a council
     * @summary Get invitation statistics
     * @param {number} councilId Council ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminInvitationsApi
     */
    public getInvitationStatistics(councilId: number, options?: RawAxiosRequestConfig) {
        return CouncilAdminInvitationsApiFp(this.configuration).getInvitationStatistics(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated list of invitations for a specific council
     * @summary Get invitations for council
     * @param {number} councilId Council ID
     * @param {number} [page] Page number (0-based)
     * @param {number} [size] Page size
     * @param {string} [sort] Sort field
     * @param {string} [direction] Sort direction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminInvitationsApi
     */
    public getInvitationsForCouncil(councilId: number, page?: number, size?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig) {
        return CouncilAdminInvitationsApiFp(this.configuration).getInvitationsForCouncil(councilId, page, size, sort, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated list of invitations sent to a specific email
     * @summary Get invitations for email
     * @param {string} email Email address
     * @param {number} [page] Page number (0-based)
     * @param {number} [size] Page size
     * @param {string} [sort] Sort field
     * @param {string} [direction] Sort direction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminInvitationsApi
     */
    public getInvitationsForEmail(email: string, page?: number, size?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig) {
        return CouncilAdminInvitationsApiFp(this.configuration).getInvitationsForEmail(email, page, size, sort, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated list of invitations sent by a specific user
     * @summary Get invitations sent by user
     * @param {number} userId User ID
     * @param {number} [page] Page number (0-based)
     * @param {number} [size] Page size
     * @param {string} [sort] Sort field
     * @param {string} [direction] Sort direction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminInvitationsApi
     */
    public getInvitationsSentByUser(userId: number, page?: number, size?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig) {
        return CouncilAdminInvitationsApiFp(this.configuration).getInvitationsSentByUser(userId, page, size, sort, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend an invitation email
     * @summary Resend invitation
     * @param {number} invitationId Invitation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminInvitationsApi
     */
    public resendInvitation(invitationId: number, options?: RawAxiosRequestConfig) {
        return CouncilAdminInvitationsApiFp(this.configuration).resendInvitation(invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accept or reject a council admin invitation
     * @summary Respond to invitation
     * @param {string} token Invitation token
     * @param {RespondCouncilAdminInvitationRequest} respondCouncilAdminInvitationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminInvitationsApi
     */
    public respondToInvitation(token: string, respondCouncilAdminInvitationRequest: RespondCouncilAdminInvitationRequest, options?: RawAxiosRequestConfig) {
        return CouncilAdminInvitationsApiFp(this.configuration).respondToInvitation(token, respondCouncilAdminInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

